import React from 'react'
import { useHistory, useLocation } from "react-router-dom";
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ServiciosPendientesChart from './ServiciosPendientesChart';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ThumbUpAlt from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAlt from "@mui/icons-material/ThumbDownAlt";
import CircularProgress from "@mui/icons-material/HourglassTop";
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import CreditScoreIcon from '@mui/icons-material/CreditScore';

const MantenimientoPanelDashboard = ({ sucursales, adr, ejercicio_inicio, ejercicio_fin, periodo_inicio, periodo_fin, filtroSucursales, serviciosPendientes }) => {
    const history = useHistory();
    // console.log(serviciosPendientes)
    const onMantenimiento = (estatus, motivo) => {
        history.push("/Postventa/Mantenimiento", {
            sucursales: sucursales,
            adr: adr,
            ejercicio_inicio: ejercicio_inicio,
            ejercicio_fin: ejercicio_fin,
            periodo_inicio: periodo_inicio,
            periodo_fin: periodo_fin,
            estatus: estatus,
            motivo: motivo,
            filtroSucursales: filtroSucursales,
        });
    };
    return (
        <div
            className="dashboard-postventa-tabla-mantenimiento-container"
        >
            <div className="header">
                <AnalyticsIcon /> Mantenimiento: {serviciosPendientes.total_mensajes}
            </div>

            {/* Contenedor Flex para las tres secciones */}
            <div className="grid-scroll-wrapper">
                <div className="grid-layout">
                    {/* Sección 1 - Chart circular */}
                    <div className="chart-container" onClick={() => onMantenimiento("CC", "CC")}>
                        {window.innerWidth < 1480 ? null : (
                            <ServiciosPendientesChart
                                percentage={serviciosPendientes.enviados_porcentaje}
                                size={90}
                            />
                        )}
                        <div className="vertical-divider"></div>
                        <div className="chart-summary">
                            <div className="detail-item">
                                <span>Total: </span>
                                <span> {serviciosPendientes.total_mensajes} | 100%</span>
                            </div>
                            <div className="detail-item">
                                <span>Enviados: </span>
                                <span> {serviciosPendientes.enviados} | {serviciosPendientes.enviados_porcentaje}%</span>
                            </div>
                            <div className="detail-item">
                                <span>Pendientes: </span>
                                <span> {serviciosPendientes.pendientes} | {serviciosPendientes.pendientes_porcentaje}%</span>
                            </div>
                            <div className="divider"></div>
                            <div className="detail-item">
                                <span><CreditScoreIcon /> Facturados: </span>
                                <span> {serviciosPendientes.facturados} | {serviciosPendientes.facturados_porcentaje}%</span>
                            </div>
                        </div>
                    </div>

                    {/* Sección 2 - Tabla de estados */}
                    <div className="table-container estado-mensajes">
                        <table>
                            <tbody>
                                <tr onClick={() => onMantenimiento("EN", "CC")}>
                                    <td>
                                        <WhatsAppIcon className="svg-color-green" />
                                    </td>
                                    <td>Enviados</td>
                                    <td>{serviciosPendientes.enviados}</td>
                                    <td>100 %</td>
                                </tr>
                                <tr onClick={() => onMantenimiento("LE", "CC")}>
                                    <td>
                                        <CircularProgress className="svg-color-blue" />
                                    </td>
                                    <td>Leídos</td>
                                    <td>{serviciosPendientes.leidos}</td>
                                    <td>{serviciosPendientes.leidos_porcentaje} %</td>
                                </tr>
                                <tr onClick={() => onMantenimiento("CI", "CC")}>
                                    <td>
                                        <ThumbUpAlt className="svg-color-green" />
                                    </td>
                                    <td>Interesados</td>
                                    <td>{serviciosPendientes.clientes_interes}</td>
                                    <td>{serviciosPendientes.clientes_interes_porcentaje} %</td>
                                </tr>
                                <tr onClick={() => onMantenimiento("SI", "CC")}>
                                    <td>
                                        <ThumbDownAlt className="svg-color-red" />
                                    </td>
                                    <td>No interesados</td>
                                    <td>{serviciosPendientes.clientes_sin_interes}</td>
                                    <td>{serviciosPendientes.clientes_sin_interes_porcentaje} %</td>
                                </tr>
                                <tr onClick={() => onMantenimiento("ER", "CC")}>
                                    <td>
                                        <ReportGmailerrorredIcon className="svg-color-red" />
                                    </td>
                                    <td>Error</td>
                                    <td>{serviciosPendientes.mensajes_error}</td>
                                    <td>{serviciosPendientes.mensajes_error_porcentaje} %</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MantenimientoPanelDashboard